(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    

 
  
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kampanya-modulu"] && !Shopify.designMode) return;
  try {
    

    function reloadCartDrawer() {
    fetch('/cart')
        .then(response => response.text())
        .then(data => {
        var parser = new DOMParser();
        var doc = parser.parseFromString(data, 'text/html');
        var newCartDrawer = doc.querySelector('.cart-drawer');

        if (newCartDrawer) {
            var oldCartDrawer = document.querySelector('.cart-drawer');
            oldCartDrawer.innerHTML = newCartDrawer.innerHTML;
        }
        
        var cartCount = doc.querySelector('.cart-count');
        if (cartCount) {
            var cartCountElement = document.querySelector('.cart-count');
            cartCountElement.textContent = cartCount.textContent;
        }
        })
        .catch((error) => {
        console.error('Sepet çekmecesi yeniden yüklenirken bir hata oluştu:', error);
        });
    }


    async function addToCart(variantId, quantity) {
        const apiEndPoint = (quantity === 0) ? 'change.js' : 'add.js';
        const uniqueKey = Date.now().toString(); 

        try {
            const response = await fetch('/cart/' + apiEndPoint, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                },
                body: JSON.stringify({
                    id: variantId,
                    quantity: quantity,
                    properties: {
                        _uniqueKey: uniqueKey,
                      camp_discount: "15"
                    }
                })
            });
            const data = await response.json();
            reloadCartDrawer();
            if (quantity === 1) { 
            return data.key; 
            }
        } catch (error) {
            console.error('Ürün sepete eklenirken hata oluştu:', error);
        }
    }


    document.getElementById('modal').addEventListener('click', function(event) {
        if (event.target === document.getElementById('modal')) {
            document.getElementById('modal').style.display = 'none';
        }
    });

    document.querySelectorAll('.camping-add-to-cart, .camping-remove-from-cart').forEach(button => {
        button.addEventListener('click', function() {
            const btn = this;
            const originalContent = btn.innerHTML;
            const campProductId = btn.getAttribute("data-product-id");
            const campItemLineKey = btn.getAttribute('data-item-line-key');

            btn.innerHTML = '<i class="fas fa-spinner fa-spin"></i>';
            setTimeout(() => {
                if (btn.classList.contains('camping-remove-from-cart')) {
                    btn.classList.remove('camping-remove-from-cart');
                    btn.classList.add('camping-add-to-cart');
                    btn.innerHTML = '<i class="fas fa-cart-plus"></i>';
                    addToCart(campItemLineKey, 0);
                } else {
                    btn.classList.remove('camping-add-to-cart');
                    btn.classList.add('camping-remove-from-cart');
                    btn.innerHTML = '<i class="fas fa-cart-arrow-down"></i>';
                    (async () => {
                        var line_item_key = await addToCart(campProductId, 1);
                        btn.setAttribute('data-item-line-key', line_item_key);
                        console.log('line_item_key: ', line_item_key);
                    })();
                }
            }, 200);
        });
    });

    function closeCampingModal() {
      console.log('closeCampingModal');
      document.getElementById('modal').style.display = 'none';
    }


  } catch(e) { console.error(e); }
})();
})();
